import React from 'react';
import classNames from 'classnames';

import './styles.scss';

import Utils from '../../../Services/Utils';
import ConfigService from '../../../Services/api/Config';
import Button from '../../Common/Button';
import FormSection from '../../Common/FormSection';
import InputText from '../../FormFields/Text';
import InputEmail from '../../FormFields/Email';
import InputTextArea from '../../FormFields/TextArea';
import InputSelect from '../../FormFields/Select';
import InputDate from '../../FormFields/Date';
import Checkbox from '../../FormFields/Checkbox';
import InputFile from '../../FormFields/File';
import InputNumber from '../../FormFields/Number';
import InputDateTime from '../../FormFields/DateTime';
import Spin from '../../Common/Spin';

import { withWorkOrderContext } from '../../../Context/WorkOrderContext';
import { withFormContext } from '../../../Context/FormContext';
import UnitsService from '../../../Services/api/Units';

class WorkOrderForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modified: false,
      valuesDisabled: {},
      disabled: false,
      loading: false
    };
  }

  componentDidMount() {
    const { workOrderContext, data, filters } = this.props;
    workOrderContext.onLoadPlatformFields(data.property, filters, data.account);
    workOrderContext.onLoadSelectUnit(data.property, filters);
    workOrderContext.onLoadSelectAccounts(data.property, filters);

    if (!data.due_date) {
      this.onSetForm({ due_date: this.getValidation('due_date', 'start_date') });
    }
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    if (!_.isEqual(prevProps.data, data)) {
      this.setState({
        modified: true,
      });
    }
  }

  onSetForm = (dataObj) => {
    const { onSetWorkOrderFormData, data, user, workOrderContext, unitData } = this.props;
    if (dataObj['unit'] && Object.keys(dataObj['unit']).length > 0 && dataObj['unit'].value) {
      this.setState({loading: true})
      UnitsService.get(dataObj['unit']['value'], { fetch_resident: true }).then((res) => {
        this.setState({loading: false})
        data['requestedBy'] = res.resident_name || (user ? `${user.first_name} ${user.last_name}` : null);
        data['phone'] = res.resident_phone;
        data['email'] = res.resident_email;
        if (workOrderContext.platformFields.pms_platform === 'entrata') {
          data['tenant_code'] = res.resident_external_id;
        }
        onSetWorkOrderFormData(dataObj, data);
      });
    } else {
      onSetWorkOrderFormData(dataObj, data);
    }
  };

  onSetCustomValue = (field, value) => {
    const { workOrderContext, data, filters } = this.props;
    const {customValuesOptions, customValuesParents, platformFields, onLoadSelectCustomValues, onSetCustomValuesParents, onLoadSelectUnit } = workOrderContext;
    let newData = { ...data.pms_extra_fields, [field.name]: value };
    if (field.label !== 'Status' && workOrderContext.platformFields.pms_platform === "entrata") {
      newData = { ...newData, status: customValuesOptions?.status?.find(status => status.label === "Open")?.value || null };
     }  
    let newCustomValuesParents = { ...customValuesParents, [field.name]: { ...customValuesParents[field.name], value: value } };
    let changeChild = null;
    if (platformFields && platformFields.fields) {
      platformFields.fields.map((element) => {
        const parent = value && value.value ? value.value : value;
        const oldParents = (customValuesParents[element.name] && customValuesParents[element.name].parents) ?
          customValuesParents[element.name].parents : [];
        const parentTypes = element.parent_types || [];
        if (parentTypes.includes(field.type) && !oldParents.map(p => p.id).includes(parent)) {
          const parentIndex = oldParents.findIndex(p => p.type === field.type);
          if (parentIndex > -1) {
            oldParents[parentIndex].id = parent;
          }
          else {
            oldParents.push({type:field.type, id:parent});
          }
          onLoadSelectCustomValues(data.property, element, oldParents.map(p => p.id), filters);
          newCustomValuesParents = { ...newCustomValuesParents, [element.name]: { value: null, parents: oldParents } };
          if (newData[element.name]) {
            changeChild = element;
          }
          newData = { ...newData, [element.name]: null };
        }
      });
    }

    if (platformFields && platformFields.override_fields) {
      platformFields.override_fields.map((element) => {
        if (element.filter_fields) {
          const filter_rule = element.filter_fields.find((f) => f === field.name);
          if (filter_rule && element.name === 'unit' && value) {
            onLoadSelectUnit(data.property, { building: value.label });
          }
        }
      });
    }

    this.onSetForm({ pms_extra_fields: newData });
    onSetCustomValuesParents(newCustomValuesParents);
    if (changeChild) {
      setTimeout(() => {
        this.onSetCustomValue(changeChild, null);
      }, 10);
    }
  };

  onSetError = (field, errorMessage) => {
    const { workOrderContext, data } = this.props;
    workOrderContext.onChangeWorkOrderError(field, errorMessage, data);
  };

  getValidation = (field_name, validation_id) => {
    const { workOrderContext } = this.props;
    const { platformFields } = workOrderContext;
    let validation = null;
    if (platformFields) {
      [...(platformFields.override_fields || []), ...(platformFields.fields || [])].filter(Boolean).forEach((field) => {
        if (field.name === field_name) {
          if ((field.field_type === 'date_field' && field[validation_id]) || (field.field_type === 'datetime_field' && field[validation_id])) {
            switch (field[validation_id]) {
              case 'yesterday':
                validation = moment().subtract(1, 'day').format('YYYY-MM-DD');
                break;
              case 'today':
                validation = moment().format('YYYY-MM-DD');
                break;
              case 'tomorrow':
                validation = moment().add(1, 'day').format('YYYY-MM-DD');
                break;
              case 'now':
                validation = moment().format('YYYY-MM-DD');
                break;
              default:
                validation = moment(field[validation_id]).format('YYYY-MM-DD');
                break;
            }
          } else {
            validation = field[validation_id];
          }
        }
      });
    }
    return validation;
  };

  isRequiredField = (field) => {
    const { workOrderContext, data } = this.props;
    const { platformFields, customValuesOptions, customConfigsForValidation } = workOrderContext;
    if (this.isDisabledField(field)) {
      return false;
    }
    let required = false;
    if (platformFields) {
      [...(platformFields.override_fields || []), ...(platformFields.fields || [])].filter(Boolean).forEach((element) => {
        if (element.name === field.name && element.required) {
          required = element.required;
        }
        if (element.choices_rules) {
          let rules = element.choices_rules.filter((c) => (c.required_on_cascade ? c.required_on_cascade.includes(field.name) : false));
          if (!Utils.isEmpty(rules)) {
            rules.map((rule) => {
              const option = data[element.name] || data.pms_extra_fields[element.name];
              if (!Utils.isEmpty(option)) {
                const option_id = Array.isArray(option) ? option.map((op) => op.id || op.value || op).join(',') : option.id || option.value || option;
                  let option_label = Array.isArray(option) ? option.map((op) => op.name || option.label).join(',') : option.name || option.label;
                if (Utils.isEmpty(option_label)) {
                  if (!Utils.isEmpty(element.choices)) {
                    option_label = element.choices.find((c) => c.id === option_id)?.label;
                  }
                  else {
                    option_label = customValuesOptions[element.name] ? (customValuesOptions[element.name].find((c) => c.value === option_id)?.label) : null;
                  }
                }
                option_label = typeof option == "boolean" ? option.toString() : option_label;
                if (rule.label) {
                  required = (rule.label === option_label) || required;
                } else {
                  required = (rule.value.toString() === option_id.toString()) || required;
                }
              }
            });
          }
        }
      });
      if (platformFields.pms_platform === 'entrata' && (field.name === 'access notes')) {
        if (data.unit) {
          required = !data.has_permission_to_enter;
        } else {
          required = false;
        }
      }
      // added code for custom configs for Yardi

      if (platformFields.pms_platform === 'yardi') {
        customConfigsForValidation.forEach((configField) => {
          if (configField.mapped_field === field.name) {
            if (configField.is_active && !configField.to_complete) {
              required = true;
            } else if (configField.is_active && configField.to_complete && data.id) {
              required = true;
            } else {
              required = false;
            }
          }
        });
      }
      
    }
    return required;
  };

  getExtraField = (field) => {
    let result = field;
    const { workOrderContext } = this.props;
    const { platformFields } = workOrderContext;
    if (platformFields) {
      [...(platformFields.override_fields || []), ...(platformFields.fields || [])].filter(Boolean).forEach((element) => {
        if (element.name === field.name) {
          result = element;
        }
      });
    }
    return result;
  };

  isDisabledField = (field, dataObj) => {
    const { workOrderContext, data } = this.props;
    const { valuesDisabled } = this.state;
    const { platformFields, customValuesOptions } = workOrderContext;
    const fieldElement = this.getExtraField(field);
    const keysEnabled = ['all', 'create'];
    let disabled = fieldElement.show_on ? !keysEnabled.includes(fieldElement.show_on) : false;

    if (fieldElement.parent_types && field.parent_types.length > 0 && !disabled) {
      if (platformFields && platformFields.fields) {
        platformFields.fields.map((parent) => {
          if (parent.type && fieldElement.parent_types.includes(parent.type)) {
            const value = data[parent.name] || data.pms_extra_fields[parent.name];
            disabled = Utils.isEmpty(value);
          }
        });
      }
    }
    if (platformFields) {
      var fields = [].concat(platformFields.override_fields, platformFields.fields).filter(Boolean);
      fields.forEach((element) => {
        if (element.choices_rules) {
          let rules = element.choices_rules.filter((c) => (c.show_on_cascade ? c.show_on_cascade.includes(field.name) : false));
          let disabled_rules = element.choices_rules.filter((c) => (c.disable_on_cascade ? c.disable_on_cascade.includes(field.name) : false));
          if (!Utils.isEmpty(rules)) {
            rules.map((rule) => {
              let option = data[element.name] || data.pms_extra_fields[element.name];
              if (!Utils.isEmpty(option)) {
                const option_id = Array.isArray(option) ? option.map((op) => op.id || op.value || op).join(',') : option.id || option.value || option;
                  let option_label = Array.isArray(option) ? option.map((op) => op.name || option.label).join(',') : option.name || option.label;
                if (Utils.isEmpty(option_label)) {
                  if (!Utils.isEmpty(element.choices)) {
                    option_label = element.choices.find((c) => c.id === option_id)?.label;
                  }
                  else {
                    option_label = customValuesOptions[element.name] ? (customValuesOptions[element.name].find((c) => c.value === option_id)?.label) : null;
                  }
                }
                option_label = typeof option == "boolean" ? option.toString() : option_label;
                if (rule.label) {
                  disabled = (rule.label === option_label) ? false : disabled;
                } else {
                  disabled = (rule.id.toString() === option_id.toString()) ? false : disabled;
                }
              }
            });
          }
          if (!Utils.isEmpty(disabled_rules)) {
            disabled_rules.map((disabled_rule) => {
              let option = data[element.name] || data.pms_extra_fields[element.name];
              if (!Utils.isEmpty(option)) {
                if (disabled_rule.id === '*') {
                  disabled = true;
                } else {
                  const option_id = Array.isArray(option) ? option.map((op) => op.id || op.value || op).join(',') : option.id || option.value || option;
                  let option_label = Array.isArray(option) ? option.map((op) => op.name || option.label).join(',') : option.name || option.label;
                  if (Utils.isEmpty(option_label)) {
                    if (!Utils.isEmpty(element.choices)) {
                      option_label = element.choices.find((c) => c.id === option_id)?.label;
                    }
                    else {
                      option_label = customValuesOptions[element.name] ? (customValuesOptions[element.name].find((c) => c.value === option_id)?.label) : null;
                    }
                  }
                  option_label = typeof option == "boolean" ? option.toString() : option_label;
                  if (disabled_rule.label) {
                    disabled = (disabled_rule.label === option_label) || disabled;
                  } else {
                    disabled = (disabled_rule.id.toString() === option_id.toString()) || disabled;
                  }
                }
              }
            });
          }
        }
        valuesDisabled[field.name] = disabled;
        this.setState({
          valuesDisabled,
        });
        return disabled;
      });
    }

    if (!Utils.isNull(valuesDisabled[field.name]) && valuesDisabled[field.name] !== disabled ) {
      valuesDisabled[field.name] = disabled;
      this.emptyFields(disabled, data, field, dataObj);
    }
    this.setState({
      valuesDisabled,
    });
    return disabled;
  };

  emptyFields = (disabled, data, field, dataObj) => {
    const {  workOrderContext: { platformFields:{ pms_platform } } } = this.props;
    const { modified } = this.state;

    if (disabled) {
      if (data.pms_extra_fields[field.name]){
        setTimeout(() => {
          if ((pms_platform === 'mri' && !['building', 'resident'].includes(field.name) && !modified) || modified) {
            this.onSetCustomValue(field, null);
          }
        }, 10);

      } else if (data[field.name]) {
        setTimeout(() => {
          if ((pms_platform === 'mri' && !['unit'].includes(field.name) && !modified) || modified) {
            const cloned_dataObj = {...dataObj};
            cloned_dataObj[field.name] = null;
            this.onSetForm(cloned_dataObj);
          }
        }, 10);
      }
    }
  };

  onClickSave = async () => {
    const { workOrderContext, onSaveData, dynamicFormDataId, onClickSaveWorkOrder, formContext, data, workOrderAnalyticsHandler } = this.props;
    const { onSubmitCreateTriggerWorkOrder, errors } = workOrderContext;
    if (this.state.disabled) {
      return;
  }
    this.setState({disabled: true});
    let dFDId = dynamicFormDataId;
    if (!dynamicFormDataId) {
      const response = await onSaveData(false,'workOrder');
      dFDId = response ? response.id : null;
    }
    if (errors['email']) {
      await formContext.submit(() => {
        // This is intentional do_something blank function
      }, errors);
    } else {
      // await formContext.submit(async () => {
      const result = await onSubmitCreateTriggerWorkOrder(data, dFDId);
      if (result) {
        const analyticsData = {
          ...data,
          id: result.id,
          priority: data?.pms_extra_fields?.priority?.label || data.pms_extra_fields?.priority || '',
          account_users_assigned: Array.isArray(data?.assignTo)
            ? data.assignTo.map(item => item?.value || item)
            : []
        };

        if (data.unit && typeof data.unit !== 'object') {
          UnitsService.get(data.unit)
            .then(unit => {
              workOrderAnalyticsHandler({
                ...analyticsData,
                unit_name : (unit?.building ? unit.building + ' - ' : '') + (unit?.number || null),
                unit_id: unit?.id,
              });
            })
            .catch(error => {
              workOrderAnalyticsHandler(analyticsData);
            });
        } else {
          workOrderAnalyticsHandler(analyticsData);
        }
        await onClickSaveWorkOrder(data);
      }
      this.setState({disabled: false});
    }
  };

  onClickCancel = () => {
    const { onClickCancelWorkOrder, data } = this.props;
    onClickCancelWorkOrder(data);
  };

  renderExtraField = (field) => {
    const { workOrderContext, data } = this.props;
    const { customValuesOptions, errors } = workOrderContext;
    const label = Utils.capitalize(field.label);
    const labelRequired =
      label +
      (this.isRequiredField(field)
        ? ` <span class='InputWrapper-Label-Required' style='color: ${ConfigService.getColor('errorColor')}'>*</span>`
        : '');
    switch (field.field_type) {
      case 'custom_value':
        return (
          <InputSelect
            className={'WorkOrderForm__Input'}
            value={data.pms_extra_fields[field.name]}
            options={customValuesOptions[field.name]}
            labelhtml={labelRequired}
            multiple={false}
            placeholder={'Select ' + label}
          defaultValue={
            field.label === 'Status' && workOrderContext.platformFields.pms_platform === "entrata"
              ? customValuesOptions?.status?.find(status => status.label === "Open") || null
              : null
          }
            onChange={(item) => {
              this.onSetCustomValue(field, item);
            }}
            disabled={this.isDisabledField(field)}
            onError={(message) => this.onSetError(field.name, message)}
            error={errors[field.name]}
          />
        );
      case 'choice_field':
        return (
          <InputSelect
            className={'WorkOrderForm__Input'}
            value={data.pms_extra_fields[field.name]}
            options={field.choices.map((item) => {
              return { value: item.id, label: item.label };
            })}
            labelhtml={labelRequired}
            multiple={false}
            placeholder={'Select ' + label}
            onChange={(item) => {
              this.onSetCustomValue(field, item);
            }}
            disabled={this.isDisabledField(field)}
            onError={(message) => this.onSetError(field.name, message)}
            error={errors[field.name]}
            isClearable={true}
          />
        );
      case 'char_field':
        return (
          <InputText
            className={'WorkOrderForm__Input'}
            value={data.pms_extra_fields[field.name]}
            labelhtml={labelRequired}
            onChange={(item) => {
              this.onSetCustomValue(field, item);
            }}
            disabled={this.isDisabledField(field)}
            debounce={0}
            onError={(message) => this.onSetError(field.name, message)}
            error={errors[field.name]}
          />
        );
      case 'text_field':
        return (
          <InputTextArea
            className={'WorkOrderForm__Input'}
            value={data.pms_extra_fields[field.name]}
            labelhtml={labelRequired}
            onChange={(item) => {
              this.onSetCustomValue(field, item);
            }}
            disabled={this.isDisabledField(field)}
            debounce={0}
            onError={(message) => this.onSetError(field.name, message)}
            error={errors[field.name]}
          />
        );
      case 'positive_integer_field':
        return (
          <InputNumber
            className={'WorkOrderForm__Input'}
            value={data.pms_extra_fields[field.name]}
            labelhtml={labelRequired}
            onChange={(item) => {
              this.onSetCustomValue(field, item);
            }}
            disabled={this.isDisabledField(field)}
            debounce={0}
            onError={(message) => this.onSetError(field.name, message)}
            error={errors[field.name]}
          />
        );
      case 'date_field':
        return (
          <InputDate
            className={'WorkOrderForm__Input'}
            value={data.pms_extra_fields[field.name]}
            labelhtml={labelRequired}
            todayButton={true}
            onChange={(item) => {
              this.onSetCustomValue(field, item);
            }}
            disabled={this.isDisabledField(field)}
            onError={(message) => this.onSetError(field.name, message)}
            error={errors[field.name]}
          />
        );
      case 'datetime_field':
        return (
          <InputDateTime
            className={'WorkOrderForm__Input'}
            value={data.pms_extra_fields[field.name]}
            labelhtml={labelRequired}
            todayButton={true}
            onChange={(item) => {
              this.onSetCustomValue(field, item);
            }}
            disabled={this.isDisabledField(field)}
            onError={(message) => this.onSetError(field.name, message)}
            error={errors[field.name]}
            startDate={this.getValidation(field.name, 'start_date')}
            endDate={this.getValidation(field.name, 'end_date')}
          />
        );
      case 'boolean_field':
        return (
          <Checkbox
            className={'WorkOrderForm__CheckBox'}
            checked={data.pms_extra_fields[field.name] ? true : false}
            disabled={this.isDisabledField(field)}
            label={field.label}
            onChange={(item) => this.onSetCustomValue(field, item)}
          />
        );
    }
  };

  renderExtraFields = () => {
    const { workOrderContext } = this.props;
    const { platformFields } = workOrderContext;
    const fields = [];
    platformFields.fields.map((field) => {
      fields.push(
        <div className={'WorkOrderForm__Input_Wrapper'} key={field.name}>
          {this.renderExtraField(field)}
        </div>
      );
    });
    return fields;
  };

  render() {
    const { workOrderContext, data } = this.props;
    const { loading } = this.state;
    
    const {
      floor,
      unit,
      requestedBy,
      service,
      phone,
      notes,
      email,
      has_permission_to_enter,
      brief_description,
      due_date,
      full_description,
      problemDescription,
      assignTo,
      attachments,
      groupId,
      realStart,
      realFinish,
      tenant_caused,
      technician_notes
    } = data;
    const { errors, unitOptions, accountsOptions, platformFields } = workOrderContext;
    let workOrderErrors = {};

    if (errors[groupId]) {
      const { id, time } = data;
      const errorLocator = (item) => (id && id === item.id) || moment(item.time).isSame(time);
      workOrderErrors = errors[groupId].find(errorLocator) ? errors[groupId].find(errorLocator).errors || {} : {};
    }
    const labelRequired = ` <span class='InputWrapper-Label-Required' style='color: ${ConfigService.getColor('errorColor')}'>*</span>`;

    return (
      <div className="WorkOrderForm">
        <FormSection
          title={'Property'}
          inputs={
            <div className={'WorkOrderForm__SectionRow'}>
              <div className={'WorkOrderForm__Input_Wrapper'}>
                <InputText
                  className={'WorkOrderForm__Input'}
                  value={floor}
                  labelhtml={'Floor' + (this.isRequiredField({ name: 'floor_code' }) ? ' ' + labelRequired : '')}
                  onChange={(floor) => this.onSetForm({ floor })}
                  debounce={0}
                  disabled={this.isDisabledField({ name: 'floor_code' })}
                  onError={(message) => this.onSetError('floor', message)}
                  error={workOrderErrors.floor}
                />
              </div>
              <div className={'WorkOrderForm__Input_Wrapper'}>
                <InputSelect
                  className={'WorkOrderForm__Input'}
                  value={unit}
                  options={unitOptions}
                  labelhtml={'Unit' + (this.isRequiredField({ name: 'unit' }) ? ' ' + labelRequired : '')}
                  placeholder={'Select Unit'}
                  multiple={false}
                  disabled={this.isDisabledField({ name: 'unit' } , { unit })}
                  onChange={(unit) => this.onSetForm({ unit })}
                  onError={(message) => this.onSetError('unit', message)}
                  error={workOrderErrors.unit}
                  isClearable={true}
                />
              </div>
            </div>
          }
        />

        <FormSection
          title={'Requestor'}
          inputs={
            <div>
              <div className={'WorkOrderForm__SectionRow'}>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputText
                    className={'WorkOrderForm__Input'}
                    value={requestedBy}
                    labelhtml={'Requested By' + (this.isRequiredField({ name: 'requester name' }) ? ' ' + labelRequired : '')}
                    onChange={(requestedBy) => this.onSetForm({ requestedBy })}
                    debounce={0}
                    disabled={this.isDisabledField({ name: 'requester name' })}
                    onError={(message) => this.onSetError('requestedBy', message)}
                    error={workOrderErrors.requestedBy}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputText
                    className={'WorkOrderForm__Input'}
                    value={phone}
                    mask={'(999) 999-9999'}
                    labelhtml={'Requestor Phone' + (this.isRequiredField({ name: 'requester phone number' }) ? ' ' + labelRequired : '')}
                    onChange={(phone) => this.onSetForm({ phone })}
                    debounce={0}
                    disabled={this.isDisabledField({ name: 'requester phone number' })}
                    onError={(message) => this.onSetError('phone', message)}
                    error={workOrderErrors.phone}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputEmail
                    className={'WorkOrderForm__Input'}
                    value={email}
                    disabled={this.isDisabledField({ name: 'requester email' })}
                    labelhtml={'Requestor Email' + (this.isRequiredField({ name: 'requester email' }) ? ' ' + labelRequired : '')}
                    onChange={(email) => this.onSetForm({ email })}
                    onError={(message) => this.onSetError('email', message)}
                    error={workOrderErrors.email}
                  />
                </div>
              </div>
              <div className={'WorkOrderForm__SectionRow'}>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputDate
                    className={'WorkOrderForm__Input'}
                    value={service}
                    onChange={(service) => this.onSetForm({ service })}
                    labelhtml={'Created Date' + (this.isRequiredField({ name: 'service request date' }) ? ' ' + labelRequired : '')}
                    todayButton={true}
                    disabled={true}
                    onError={(message) => this.onSetError('service', message)}
                    error={workOrderErrors.service}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper WorkOrderForm__TextArea'}>
                  <InputTextArea
                    className={'WorkOrderForm__TextArea'}
                    value={notes}
                    disabled={this.isDisabledField({ name: 'access notes' })}
                    labelhtml={'Access Notes' + (this.isRequiredField({ name: 'access notes' }) ? ' ' + labelRequired : '')}
                    onChange={(notes) => this.onSetForm({ notes })}
                    onError={(message) => this.onSetError('notes', message)}
                    error={workOrderErrors.notes}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <Checkbox
                    className={'WorkOrderForm__CheckBox'}
                    checked={has_permission_to_enter}
                    disabled={this.isDisabledField({ name: 'has_permission_to_enter' })}
                    label={'Permission To Enter'}
                    onChange={() => this.onSetForm({ has_permission_to_enter: !has_permission_to_enter })}
                    onError={(message) => this.onSetError('has_permission_to_enter', message)}
                    error={workOrderErrors.has_permission_to_enter}
                  />
                </div>
              </div>
            </div>
          }
        />

        <FormSection
          title={'Repair Detail'}
          inputs={
            <div>
              <div className={'WorkOrderForm__SectionRow'}>
                <div className={'WorkOrderForm__Input_Wrapper WorkOrderForm__TextArea'}>
                  <InputTextArea
                    className={'WorkOrderForm__TextArea'}
                    value={brief_description}
                    disabled={this.isDisabledField({ name: 'brief_description' })}
                    labelhtml={'Brief Description' + (this.isRequiredField({ name: 'brief_description' }) ? ' ' + labelRequired : '')}
                    onChange={(brief_description) => this.onSetForm({ brief_description })}
                    onError={(message) => this.onSetError('brief_description', message)}
                    error={workOrderErrors.brief_description}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper WorkOrderForm__TextArea'}>
                  <InputTextArea
                    className={'WorkOrderForm__TextArea'}
                    value={full_description}
                    disabled={this.isDisabledField({ name: 'full_description' })}
                    labelhtml={'Full Description' + (this.isRequiredField({ name: 'full_description' }) ? ' ' + labelRequired : '')}
                    onChange={(full_description) => this.onSetForm({ full_description })}
                    onError={(message) => this.onSetError('full_description', message)}
                    error={workOrderErrors.full_description}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper WorkOrderForm__TextArea'}>
                  <InputTextArea
                    className={'WorkOrderForm__TextArea'}
                    value={problemDescription}
                    disabled={this.isDisabledField({ name: 'problem description notes' })}
                    labelhtml={'Problem Description' + (this.isRequiredField({ name: 'problem description notes' }) ? ' ' + labelRequired : '')}
                    onChange={(problemDescription) => this.onSetForm({ problemDescription })}
                    onError={(message) => this.onSetError('problemDescription', message)}
                    error={workOrderErrors.problemDescription}
                  />
                </div>
              </div>
              <div className={'WorkOrderForm__SectionRow'}>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputDate
                    className={'WorkOrderForm__Input'}
                    value={due_date}
                    onChange={(due_date) => this.onSetForm({ due_date })}
                    labelhtml={'Due Date' + (this.isRequiredField({ name: 'due_date' }) ? ' ' + labelRequired : '')}
                    todayButton={true}
                    disabled={this.isDisabledField({ name: 'due_date' })}
                    startDate={this.getValidation('due_date', 'start_date')}
                    onError={(message) => this.onSetError('due_date', message)}
                    error={workOrderErrors.due_date}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputSelect
                    className={'WorkOrderForm__Input'}
                    value={assignTo}
                    options={accountsOptions}
                    labelhtml={'Assign To' + (this.isRequiredField({ name: 'account users assigned' }) ? ' ' + labelRequired : '')}
                    multiple
                    placeholder={'Select User'}
                    disabled={this.isDisabledField({ name: 'account users assigned' })}
                    onChange={(assignTo) => this.onSetForm({ assignTo })}
                    onError={(message) => this.onSetError('assignTo', message)}
                    error={workOrderErrors.assignTo}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputFile
                    labelhtml={'Attachments' + (this.isRequiredField({ name: 'attachments' }) ? ' ' + labelRequired : '')}
                    placeholder="Drag your files here or click to upload"
                    multiple={true}
                    value={attachments}
                    disabled={this.isDisabledField({ name: 'attachments' })}
                    onChange={(attachments) => this.onSetForm({ attachments })}
                    onError={(message) => this.onSetError('attachments', message)}
                    error={workOrderErrors.attachments}
                  />
                </div>
              </div>
              <div className={'WorkOrderForm__SectionRow'}>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputDateTime
                    className={'WorkOrderForm__Input'}
                    value={realStart}
                    onChange={(realStart) => this.onSetForm({ realStart })}
                    labelhtml={'Real Start' + (this.isRequiredField({ name: 'real_start' }) ? ' ' + labelRequired : '')}
                    todayButton={true}
                    disabled={this.isDisabledField({ name: 'real_start' })}
                    endDate={ realFinish || this.getValidation('real_start', 'end_date')}
                    onError={(message) => this.onSetError('realStart', message)}
                    error={workOrderErrors.realStart}
                  />
                </div>
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <InputDateTime
                    className={'WorkOrderForm__Input'}
                    value={realFinish}
                    onChange={(realFinish) => this.onSetForm({ realFinish })}
                    labelhtml={'Real Finish' + (this.isRequiredField({ name: 'real_finish' }) ? ' ' + labelRequired : '')}
                    todayButton={true}
                    disabled={this.isDisabledField({ name: 'real_finish' })}
                    startDate={realStart}
                    endDate={this.getValidation('real_finish', 'end_date')}
                    onError={(message) => this.onSetError('realFinish', message)}
                    error={workOrderErrors.realFinish}
                  />
                </div>
              </div>
            </div>
          }
        />

        <FormSection
          title={'Additional Information'}
          inputs={
            <div className={'WorkOrderForm__SectionRow WorkOrderForm__SectionRow_Platform'}>
              {this.renderExtraFields()}
              {platformFields?.pms_platform == 'yardi' &&
                <div className={'WorkOrderForm__Input_Wrapper'}>
                  <Checkbox
                    className={'WorkOrderForm__CheckBox'}
                    checked={tenant_caused}
                    disabled={this.isDisabledField({ name: 'tenant_caused' })}
                    label={' Tenant Responsible'}
                    onChange={() => this.onSetForm({ tenant_caused: !tenant_caused })}
                    onError={(message) => this.onSetError('tenant_caused', message)}
                    error={workOrderErrors.tenant_caused}
                  />
                </div>
              }
              {platformFields?.pms_platform == 'yardi' &&
                <div className={'WorkOrderForm__Input_Wrapper WorkOrderForm__TextArea'}>
                  <InputTextArea
                    className={'WorkOrderForm__TextArea'}
                    value={technician_notes}
                    disabled={this.isDisabledField({ name: 'technician_notes' })}
                    labelhtml={'Technician Notes' + (this.isRequiredField({ name: 'technician_notes' }) ? ' ' + labelRequired : '')}
                    onChange={(technician_notes) => this.onSetForm({ technician_notes })}
                    onError={(message) => this.onSetError('technician_notes', message)}
                    error={workOrderErrors.technician_notes}
                  />
                </div>
              }
            </div>
          }
        />

        <div className={classNames('WrapperDynamicForm_Actions Center')}>
          <Button className={'Button_Small Inline'} onClick={this.onClickSave} btnText={'Save'} disabled={this.state.disabled}/>

          <Button className={'Button_Small Button_Cancel Inline'} onClick={this.onClickCancel} btnText={'Cancel'} />
        </div>
        
        {loading && <Spin />}
      </div>
    );
  }
}

export default withFormContext(withWorkOrderContext(WorkOrderForm));
